import React from 'react';

import { Menu as MuiMenu, MenuProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { menuClassStyles } from './menuStyles';

export type { MenuProps };

export const Menu: React.ComponentType<MenuProps> = styled((props: MenuProps) => (
  <MuiMenu
    slotProps={{
      paper: {
        sx: {
          minWidth: 320,
          maxHeight: 320,
        },
      },
    }}
    {...props}
  />
))<MenuProps>(() => menuClassStyles);
